import { createGlobalState } from '@vueuse/core';

// for asyncQueue to work dbs must raise rejections, otherwise queue will not continue
export const useAsyncQueue = () => {
    let waitingPromise: Promise<unknown> = Promise.resolve();
    return function<T>(promiseFn: () => Promise<T>): Promise<T> {
        const promise = waitingPromise.catch(() => {}).then(promiseFn);
        waitingPromise = promise;
        return promise;
    };
};

export const useGlobalAsyncQueue = createGlobalState(() => useAsyncQueue());
